import { createFileRoute } from '@tanstack/react-router'
import EditionCopy from 'Edition/components/sections/Copy/EditionCopy'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/copyproduction')({
    component: EditionCopy,
})
